<template>
  <button type="button" class="inner_item"
    :disabled="isEditMode"
    @click="onSortItemClick">
    <span style="display: inline-block;"><slot/></span>
    <template v-if="isEditMode">
      <i v-if="sortColumn === columnName"
       class="sort_icon icon icon--sorting-white"
      :class="{ asc: isSortAsc }"></i>
    </template>
    <i v-else
      class="sort_icon icon icon--sorting-default"
      :class="{
        asc: sortColumn === columnName && isSortAsc,
        desc: sortColumn === columnName && !isSortAsc
      }"></i>
  </button>
</template>

<script>
export default {
  name: 'SortOptions',
  props: [
    'columnName',
    'sortColumn',
    'isSortAsc',
    'isEditMode'
  ],
  data () {
    return {
    }
  },
  methods: {
    onSortItemClick () {
      const columnName = this.columnName
      let isAsc = true

      if (this.sortColumn === columnName) {
        isAsc = !this.isSortAsc
      }
      this.$emit('onSortOptionChange', columnName, isAsc)
    }
  }
}
</script>

<style lang="scss" scoped>
.inner_item {
  color: inherit;
  font-weight: inherit;
  position: relative;
  line-height: inherit;
  display: inline-block;
  vertical-align: middle;

  &[disabled] {
    cursor: default;
  }

  &> span {
    vertical-align: middle;
    display: inline-block;
  }

  i {
    vertical-align: middle;
  }
}
.sort_icon {
  margin-left: 2px;
  vertical-align: middle;
}
</style>
